import * as React from "react";
const SvgInactiveStepIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 9, fill: "none", stroke: "currentColor", strokeWidth: 2 }));
export default SvgInactiveStepIcon;
